import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Layout";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!loading && user?.role === "admin") navigate("/admin/dashboard"); }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); navigate("/admin/dashboard"); }
    catch (e2) { setErr(typeof e2.response?.data?.detail === "string" ? e2.response.data.detail : "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid-bg flex flex-col items-center justify-center px-4">
      <div className="mb-8"><Logo /></div>
      <form onSubmit={submit} data-testid="admin-login-form" className="card p-8 w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6"><Lock size={16} className="text-[#84CC16]" /><span className="eyebrow">Admin access</span></div>
        <input data-testid="admin-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#0B0F17] border border-white/10 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 mb-3" />
        <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0B0F17] border border-white/10 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 mb-4" />
        {err && <p data-testid="admin-login-error" className="text-red-400 text-sm mb-3">{err}</p>}
        <button data-testid="admin-login-submit" type="submit" disabled={busy}
          className="w-full bg-[#2563EB] hover:bg-[#3B82F6] text-white font-bold py-3 rounded-lg transition-colors disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
